import { Injectable, signal, WritableSignal } from '@angular/core';

export interface ToastProps {
  id?: number;
  body: string;
  heading?: string;
  icon?: string;
  appearance?: string;
  duration?: number;
  position?: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toasts: WritableSignal<ToastProps[]> = signal([]);
  private idCounter = 0;

  showToast(
    body: string,
    heading = '',
    icon = '',
    appearance = 'neutral',
    position = 'top-center',
    duration = 3000,
  ): void {
    const id = ++this.idCounter;
    const toast: ToastProps = { id, heading, body, icon, appearance, duration, position };
    this.toasts.set([...this.toasts(), toast]);
  }

  showSuccess(
    body = '',
    heading = '',
    icon = 'check-circle',
    position = 'top-center',
  ): void {
    this.showToast(body, heading, icon, 'success', position);
  }

  showError(
    body = '',
    heading = '',
    icon = 'exclamation-circle',
    position = 'top-center',
  ): void {
    this.showToast(body, heading, icon, 'error', position);
  }

  getToasts(): WritableSignal<ToastProps[]> {
    return this.toasts;
  }

  clearNotification(id: number): void {
    this.toasts.set(this.toasts().filter((t) => t.id !== id));
  }

  clearAll(): void {
    this.toasts.set([]);
  }
}
